import React, { useState, useEffect } from "react";
import "./NacePayment.scss";

const NacePayWidget = ({ nacePayment, open, setOpen }) => {
  useEffect(() => {
    // Dynamically load the NacePay script when component mounts
    const conditionMet = true; // Replace with your actual condition logic

    if (conditionMet) {
      const script = document.createElement("script");
      script.src = "https://apps.newagecrypto.com/widget/nacepay.js?v4";
      script.async = true; // Make sure it loads asynchronously
      document.body.appendChild(script);

      // Cleanup the script when the component is unmounted
      return () => {
        document.body.removeChild(script);
      };
    }
  }, [nacePayment]);

  const handleCloseModal = () => {
    setOpen(false); // Close the modal
  };
  useEffect(() => {
    if (open) {
      const style = document.createElement("style");
      style.id = "custom-body-style"; // Add an ID to track the style
      style.innerHTML = "body { color: black !important; }";
      document.head.appendChild(style);
  
      // Cleanup function
      return () => {
        document.head.removeChild(style);
      };
    }
  }, [open]);
  

  return (
    <>
      {open && (
        <div
          style={{ display: open ? "block" : "none" }}
          className="nacemodal_container"
          onClick={handleCloseModal}
        >
          <div
            className="nacemodal"
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
          >
            <div
              nacepay="Paywidget"
              nacepay_id="4bf3f63f-06e9-4ddd-a662-e4d12a46dfe7"
              amount={nacePayment?.amount}
              currency="USD"
              ref_id={nacePayment?.id}
              className="nacepaypaybtn"
            ></div>
            <p>Please click on this button to continue</p>
          </div>
        </div>
      )}
    </>
  );
};

export default NacePayWidget;
